import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

function Divider({ visible, mobileOnly }) {
  if (!visible) { return null; }

  const rowClasses = cx({
    'row': true,
    'hidden-print': true,
    'visible-lte-sm': mobileOnly,
  });

  return (
    <div className={rowClasses}>
      <hr className="ticket-section-break col-xs-10 col-xs-offset-1 col-md-12 col-md-offset-0 padding-0" />
    </div>
  );
}

Divider.propTypes = {
  visible: PropTypes.bool.isRequired,
  mobileOnly: PropTypes.bool,
};

Divider.defaultProps = {
  mobileOnly: false,
};

export default Divider;
